import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteHeadHuntApplicationModel} from '../Model'
import {actionTypes} from './constants'

export const actions = {
  getHeadHuntApplications: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATIONS_START,
    payload: params,
  }),

  getHeadHuntApplicationsSuccess: (data: any) => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATIONS_SUCCESS,
    payload: data,
  }),
  getHeadHuntApplicationsFinish: () => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATIONS_FINISH,
  }),
  getHeadHuntApplicationsError: (error: unknown) => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATIONS_FINISH,
    payload: {error},
  }),

  updateHeadHuntApplications: (data: any, id: string) => ({
    type: actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_START,
    payload: {data, id},
  }),
  updateHeadHuntApplicationsSuccess: (task: any) => ({
    type: actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_SUCCESS,
    payload: task,
  }),
  updateHeadHuntApplicationsFinish: () => ({
    type: actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_FINISH,
  }),
  updateHeadHuntApplicationsReset: () => ({
    type: actionTypes.UPDATE_HEAD_HUNT_APPLICATIONS_RESET,
  }),

  deleteHeadHuntApplications: (data: DeleteHeadHuntApplicationModel[]) => ({
    type: actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_START,
    payload: {headHuntApplicantId: data},
  }),
  deleteHeadHuntApplicationsSuccess: (data: any) => ({
    type: actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_SUCCESS,
    payload: data,
  }),
  deleteHeadHuntApplicationsFinish: () => ({
    type: actionTypes.DELETE_HEAD_HUNT_APPLICATIONS_FINISH,
  }),

  // Get single head hunt application detail (view-details modal)
  getHeadHuntApplication: (id: string) => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATION_START,
    payload: id,
  }),
  getHeadHuntApplicationSuccess: (data: any) => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATION_SUCCESS,
    payload: data,
  }),
  getHeadHuntApplicationFinish: () => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATION_FINISH,
  }),
  getHeadHuntApplicationReset: () => ({
    type: actionTypes.GET_HEAD_HUNT_APPLICATION_RESET,
  }),
}
